(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/favorites/assets/javascripts/collections/favoriteleaguelist.js') >= 0) return;  svs.modules.push('/components/sport/favorites/assets/javascripts/collections/favoriteleaguelist.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs.sport = svs.sport || {};
  svs.sport.favorites = svs.sport.favorites || {};
  svs.sport.favorites.collections = svs.sport.favorites.collections || {};

  svs.sport.favorites.collections.FavoriteLeagueList = Backbone.Collection.extend(
    {
      initialize: function() {},
      toSaveData: function() {
        var saveData = [];
        this.each(function(league) {
          var leagueId = league.get('LeagueId');
          if (leagueId) {
            saveData.push(leagueId);
          }
        });
        return saveData;
      },
      moveUp: function(model) {
        var index = this.indexOf(model);
        if (index > 0) {
          this.remove(model, { silent: true }); 
          this.add(model, { at: index - 1 });
          return true;
        }
        return false;
      },
      moveDown: function(model) {
        var index = this.indexOf(model);
        if (index < this.length - 1) {
          this.remove(model, { silent: true }); 
          this.add(model, { at: index + 1 });
          return true;
        }
        return false;
      },
      modify: function(data) {
        var model = this.findWhere({ LeagueId: data.model.get('id') });
        if (model !== undefined) {
          this.remove(model);
        } else {
          this.add(
            new this.model({
              LeagueId: data.model.get('id'),
              LeagueName: data.model.get('name')
            })
          );
        }
      }
    }
  );
})(this.Backbone, this._, this.svs);

 })(window);